import { INTENSITY_MAX_OL, INTENSITY_MAX_VL } from '@kissui/components'

export const getMaxIntensity = ({ technologies }) =>
    technologies.indexOf('original') !== -1 ? INTENSITY_MAX_OL : INTENSITY_MAX_VL
